import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import moment, { Moment } from 'moment';

export class FormsHelper {
  public static trimValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value) {
        const trimmedValue = control.value.trim();
        if (trimmedValue !== control.value) {
          // Update the control value to the trimmed value
          control.setValue(trimmedValue);
        }
      }
      return null; // Return null if validation passes
    };
  }

  public static noWhiteSpaceValidator(control: FormControl<string>): ValidationErrors | null {
    if (/\s/.test(control.value)) {
      return { whitespace: 'general.whitespace-validation-error' };
    }
    return null;
  }

  public static dateValidator(dateBoundaries: { minDate?: Moment; maxDate?: Moment }): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value === null) return null;
      const { minDate, maxDate } = dateBoundaries;

      if (!minDate && !maxDate) throw Error('Either minDate or maxDate is required');

      if (minDate && moment(control.value).isBefore(minDate, 'day')) {
        return { minDate: 'general.min-date-error' };
      }

      if (maxDate && moment(control.value).isAfter(maxDate, 'day')) {
        return { maxDate: 'general.max-date-error' };
      }

      return null;
    };
  }

  public static dateValidatorWithCondition(
    dateBoundaries: { minDate?: Moment; maxDate?: Moment },
    ignoreIf: (abstractControl: AbstractControl) => boolean
  ): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value === null) return null;
      const { minDate, maxDate } = dateBoundaries;

      if (!minDate && !maxDate) throw Error('Either minDate or maxDate is required');

      if (control.value < minDate && !ignoreIf(control)) {
        return { minDate: 'general.min-date-error' };
      }

      if (control.value > maxDate && !ignoreIf(control)) {
        return { maxDate: 'general.max-date-error' };
      }

      return null;
    };
  }

  public static prohibitedValueValidator(prohibitedValues: unknown[]): ValidatorFn {
    const valuesAsSet = new Set(prohibitedValues);

    return (control: AbstractControl): ValidationErrors | null => {
      if (valuesAsSet.has(control.value)) {
        return { notAllowed: 'general.value-not-allowed-error' };
      }

      return null;
    };
  }
}
